import React, { useState } from "react";
import File from "../../../services/File";
import styles from "./UploadFiles.module.scss";
import IconBin from "../../../assets/img/bin.png";
import IconAttach from "../../../assets/img/attach.png";
import { ReactComponent as AttachIcon } from "../../../assets/svg/zalacznik2.svg";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import Button from "@material-ui/core/Button";
import classNames from "classnames";

const UploadFiles = (props) => {
  const [selectedFiles, setSelectedFiles] = useState(undefined);
  const [currentFile, setCurrentFile] = useState(undefined);
  const [progress, setProgress] = useState(0);
  const [message, setMessage] = useState("");
  const [isOpenConfirm, setIsOpenConfirm] = useState(false);

  const [fileInfos, setFileInfos] = useState([]);

  const selectFile = (event) => {
    setSelectedFiles(event.target.files);
    upload(event.target.files);
  };

  const upload = (files) => {
    let currentFile;
    selectedFiles ? (currentFile = selectedFiles[0]) : (currentFile = files[0]);
    let tmpInfo = {};

    setProgress(0);
    setCurrentFile(currentFile);
    props.manageFileList("uploadInProgress");

    File.upload(currentFile, (event) => {
      setProgress(Math.round((100 * event.loaded) / event.total));
    })
      .then((response) => {
        setMessage(response.data.message);

        const newInfos = [...fileInfos];
        tmpInfo = {
          id: response.data.data.id,
          name: response.data.data.message.split(": ")[1],
          url: response.data.data.url,
        };
        newInfos.push(tmpInfo);
        setFileInfos(newInfos);
        setCurrentFile(undefined);
        props.manageFileList("add", response.data.data.id);
      })
      .catch(() => {
        setProgress(0);
        setMessage("Nie udało się przesłać pliku!");
        setCurrentFile(undefined);
      });

    setSelectedFiles(undefined);
  };

  const showRemoveConfirm = (id) => {
    setIsOpenConfirm(true);
  };

  const remove = (id) => {
    props.manageFileList("remove", id);
    let tmpFiles = [...fileInfos].filter((i) => i.id !== id);
    if (tmpFiles) {
      setFileInfos(tmpFiles);
    }
    setIsOpenConfirm(false);
  };

  return (
    <div className={styles.UploadImages}>
      <label
        className={classNames({
          [styles.browseButton]: true,
          [styles.disabled]: currentFile,
        })}
      >
        <AttachIcon /> Załącz plik
        <input type="file" onChange={selectFile} disabled={currentFile} />
      </label>

      <div>{message}</div>

      <ul className={styles.listFiles}>
        {fileInfos &&
          fileInfos.map((file, index) => (
            <li key={index}>
              <a href={file.url}>{file.name}</a>
              <span>
                <img
                  src={IconBin}
                  alt="remove"
                  className={styles.remove}
                  onClick={() => {
                    showRemoveConfirm(file.id);
                  }}
                />
              </span>
              <Dialog open={isOpenConfirm}>
                {/*<DialogTitle id="alert-dialog-title">Na pewnie chcesz usunąć ten plik?</DialogTitle>*/}
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    Na pewnie chcesz usunąć ten plik?
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => remove(file.id)} color="primary">
                    Usuń
                  </Button>
                  <Button
                    onClick={() => setIsOpenConfirm(false)}
                    color="primary"
                    autoFocus
                  >
                    Anuluj
                  </Button>
                </DialogActions>
              </Dialog>
            </li>
          ))}
        {currentFile && (
          <li className={styles.current} key="current">
            <span>{currentFile.name}</span>
            <span>
              <span className={styles.progress}>
                <span
                  className={styles.percent}
                  style={{ width: progress + "%" }}
                ></span>
              </span>
              {/*<img src={IconBin} alt="remove" className={styles.remove} />*/}
            </span>
          </li>
        )}
      </ul>
    </div>
  );
};

export default UploadFiles;
